var adplayer = null;
var aiptag = aiptag || {};
aiptag.cmd = aiptag.cmd || [];
aiptag.cmd.player = aiptag.cmd.player || [];
aiptag.cmd.display = aiptag.cmd.display || [];
aiptag.gdprShowConsentTool = true;

aiptag.cmd.player.push(function() {
    adplayer = new aipPlayer({
        AD_WIDTH: 960,
        AD_HEIGHT: 540,
        AD_FULLSCREEN: true,
        LOADING_TEXT: 'Loading Advertisement',
        PREROLL_ELEM: function(){return document.getElementById('preroll')},
        AIP_COMPLETE: function ()  {
            $('#preroll').hide();
            game.videoComplete();
        },
        AIP_REMOVE: function ()  {

        }
    });
});

(function() {
    let hasShownAd = false;

    game.services.ad = {
        checkShowVideoAd: function() {
            var lastVidCheck = 0;
            try {
                lastVidCheck = parseInt(window.localStorage.getItem('lastVidCheck'));
            } catch (e) {}
            if (!lastVidCheck) {
                lastVidCheck = 0;
            }

            if (lastVidCheck >= 3) {
                try {
                    window.localStorage.setItem('lastVidCheck', 0);
                } catch (e) {}

                $('#preroll-container').show();
                if (typeof adplayer !== 'undefined') {
                    aiptag.cmd.player.push(function () {
                        adplayer.startPreRoll();
                    });
                }
                return true;
            } else {
                try {
                    window.localStorage.setItem('lastVidCheck', lastVidCheck + 1);
                } catch (e) {}
            }

            return false;
        },
        showBannerAd: function() {
            setTimeout(function() {
                if (game.isPlayScreen) {
                    $('#ad-game').show();
                } else {
                    $('#ad-menu').show();
                }

                let showAd = true;
                if (game.isPlayScreen && isMobile) {
                    showAd = false;
                }

                if (showAd) {
                    aiptag.cmd.display.push(function() {
                        aipDisplayTag.display('antwar-io_300x250');
                        //hasShownAd = true;
                    });
                }
            }, 5);
        },
        hideBannerAd: function() {
            if (window.location.pathname === '/play/') {
                $('#ad-game').hide();
            } else {
                $('#ad-menu').hide();
            }
            $('#antwar-io_300x250').hide();
        }
    };
})();
